// extracted by mini-css-extract-plugin
export default {"socialMediaIcons":"user-profile_socialMediaIcons__mOPkq","twitterIcon":"user-profile_twitterIcon__djKYI"};